<div class="layout-ParentDiv innerDiv UserRedemptionPage"
  [ngClass]="hide ? 'hide-bank-small  ' : 'show-bank-details-section '">
  <div class="layout-dashboard">
    <p-toast key="toastmsg"></p-toast>

    <div class="show-table-active" [ngClass]="hide ? 'show-table-active   ' : 'show-table-active  '">
      <p-toast key="toastmsg"></p-toast>

      <div class="mainDivHeader">
        <div class="leftdiv">
          <h4>Academy Affiliation Revenue<span class="badge">{{ totalRecords }}</span></h4>
        </div>

        <div class="rightDiv">
          <button class="exportBTn" (click)="exportExcel()"> <span><img
                src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
            Export</button>
        </div>
      </div>

      <div class="mainDivBody"> 
        <div class="date-filterDiv">
          <ul class="filtersList">
            <li>
              <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
                optionLabel="label"></p-dropdown>
            </li>
            <li>
              <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="startDate"
                class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"
                placeholder="FROM: dd / mm / yy"></p-calendar>
            </li>
            <li>
              <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="endDate"
                class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"
                placeholder="To: dd / mm / yy"></p-calendar>
            </li>
            <li>
              <button (click)="loadAcademyAffiliationRevenue(lastTableLazyLoadEvent)" class="searchFilterBtn">
                <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
              </button>
            </li>
            <li>
              <button (click)="clear()" class="clearFilterBtn">
                <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                <span>Clear All</span>
              </button>
            </li>
          </ul>
            <div class="divider ">
            <hr>
          </div>
            <div class="filterTitle">
            <h5>Filters</h5> 
            <span class="text-danger fw-bold mb-3">Note:</span>
            <ul class="mb-3">
              <li>Please select a Country first to view available States.</li>
              <li>Please select a State first to view available Cities.</li>
            </ul>
        </div>
          <div class="maincard">
          <div class="filterList">
            <ul>
              <li>
   <p-dropdown inputId="totalCoaches" [options]="countrylist" [filter]="true"
                    (onChange)="getStates($event)" placeholder="Select Country" optionLabel="name" appendTo="body"
                    [showClear]="true" [(ngModel)]="country"></p-dropdown>
              </li>
            
              <li>
                 <p-dropdown inputId="totalCoaches" [options]="stateList" [filter]="true"
                    (onChange)="getCities($event)" placeholder="Select State" optionLabel="name" appendTo="body"
                    [showClear]="true" [(ngModel)]="state"></p-dropdown>
              </li>
                <li>
   <p-dropdown inputId="totalCoaches" [options]="cityList" [filter]="true"
                    (onChange)="loadAcademyAffiliationRevenue(lastTableLazyLoadEvent)" placeholder="Select City"
                    optionLabel="name" optionValue="name" appendTo="body" [showClear]="true"
                    [(ngModel)]="cityName"></p-dropdown>
              </li>
                <li>
  <p-dropdown inputId="totalCoaches" [options]="sportList" [filter]="true"
                    (onChange)="loadAcademyAffiliationRevenue(lastTableLazyLoadEvent)" placeholder="Select Sport"
                    optionLabel="name" optionValue="name" appendTo="body" [showClear]="true"
                    [(ngModel)]="sportName"></p-dropdown>
              </li>
              <li>
                  <p-dropdown inputId="totalCoaches" [options]="academiesList" [filter]="true"
                    (onChange)="loadAcademyAffiliationRevenue(lastTableLazyLoadEvent)" placeholder="Select Academy"
                    optionLabel="name" optionValue="id" appendTo="body" [showClear]="true"
                    [(ngModel)]="academyId"></p-dropdown>
              </li>
            
            </ul>
          </div>  
        </div> 
        <div class="detailsList">
          <ul>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Number of Academies</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ academyAffiliationRevenueData?.summary?.totalNumberOfAcademies }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Platinum Affiliations</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ academyAffiliationRevenueData?.summary?.totalPlatinumAffiliations }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Revenue - Platinum Affiliations</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ academyAffiliationRevenueData?.summary?.revenuePlatinumAffiliations }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Gold Affiliations</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ academyAffiliationRevenueData?.summary?.totalGoldAffiliations }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Revenue - Gold Affiliations</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ academyAffiliationRevenueData?.summary?.revenueGoldAffiliations }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Silver Affiliations</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ academyAffiliationRevenueData?.summary?.totalSilverAffiliations }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Revenue - Silver Affiliations</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ academyAffiliationRevenueData?.summary?.revenueSilverAffiliations }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Coupon Amount</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ academyAffiliationRevenueData?.summary?.couponAmount }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Revenue</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ academyAffiliationRevenueData?.summary?.totalRevenue }}</h3>
                  </div>
              </div>
            </li>
          </ul>
        </div>  
        </div>
        <div class="maintableDiv">
          <div class="tableParanet">
            <p-table class="expandable" #dt [value]="academyAffiliationRevenueData?.data" [autoLayout]="true"
              [paginator]="true" [rows]="10" [lazy]="true" [scrollable]="true" scrollHeight="auto"
              scrollDirection="both" (onLazyLoad)="loadAcademyAffiliationRevenue($event)" [totalRecords]="totalRecords"
              [loading]="loading" [rowsPerPageOptions]="paginationOption"
              styleClass="p-datatable-gridlines p-datatable-striped">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th pfrozencolumn="" class="userNameTD p-element text-nowrap" style="left: 0px"
                    pSortableColumn="mobileNumber">
                    <div class="p-d-flex p-jc-between p-ai-center"> Mobile Number <p-sortIcon
                        field="mobileNumber"></p-sortIcon>
                    </div>
                  </th>

                  <th pSortableColumn="academyName" class="userNameTD">
                    <div class="p-d-flex p-jc-between p-ai-center"> Academy Name <p-sortIcon
                        field="academyName"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="affiliationId" class="userNameTD">
                    <div class="p-d-flex p-jc-between p-ai-center"> Affiliation ID <p-sortIcon
                        field="affiliationId"></p-sortIcon>
                    </div>
                  </th>
                  <th class="userNameTD" pSortableColumn="affiliationLevel">
                    <div class="p-d-flex p-jc-between p-ai-center"> Affiliation level <p-sortIcon
                        field="affiliationLevel"></p-sortIcon>
                    </div>
                  </th>
                  <th class="transferCreditTD" pSortableColumn="affiliationStartDate">
                    <div class="p-d-flex p-jc-between p-ai-center"> Affilliation Start Date <p-sortIcon
                        field="affiliationStartDate"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="affiliationEndDate"
                    [ngClass]="hide ? 'hide-bank-small  ' : 'show-bank-small '">
                    <div class="p-d-flex p-jc-between p-ai-center"> Affilliation End Date <p-sortIcon
                        field="affiliationEndDate"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="city">
                    <div class="p-d-flex p-jc-between p-ai-center"> City <p-sortIcon field="city"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="state"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> State <p-sortIcon
                        field="state"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="country"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Country <p-sortIcon
                        field="country"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="address"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Address <p-sortIcon
                        field="address"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="affiliationAmount"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Affiliation amount <p-sortIcon
                        field="affiliationAmount"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="couponApplied"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Coupon Applied <p-sortIcon
                        field="couponApplied"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="couponAmount"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Coupon Amount <p-sortIcon
                        field="couponAmount"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="totalAffiliationAmount"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Total Affiliation Amount <p-sortIcon
                        field="totalAffiliationAmount"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="gstAmount"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> GST Amount <p-sortIcon
                        field="gstAmount"></p-sortIcon>
                    </div>
                  </th>
                  <th class="sorting_disabled text-nowrap p-element p-frozen-column action-button-td" rowspan="1"
                    colspan="1" style="justify-content: center;">
                    <div>Action</div>
                  </th>
                </tr>

                <tr>
                  <th pfrozencolumn="" class="userNameTD p-element text-nowrap">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'mobileNumber', 'contains')"
                      [value]="dt.filters['mobileNumber'] ? dt.filters['mobileNumber'].value : ''" />
                  </th>

                  <th class="userNameTD p-element text-nowrap" style="left: 0px">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'academyName', 'contains')"
                      [value]="dt.filters['academyName'] ? dt.filters['academyName'].value : ''" />
                  </th>
                  <th class="userNameTD">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'affiliationId', 'contains')"
                      [value]="dt.filters['affiliationId'] ? dt.filters['affiliationId'].value : ''" />
                  </th>
                  <th class="userNameTD p-element text-nowrap" style="left: 0px">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'affiliationLevel', 'contains')"
                      [value]="dt.filters['affiliationLevel'] ? dt.filters['affiliationLevel'].value : ''" />
                  </th>
                  <th class="transferCreditTD p-element text-nowrap"
                    style="left: 0px">
                    <input pInputText type="date"
                      (change)="setDownloadFlag(); dt.filter($event.target.value, 'affiliationStartDate', 'equals')"
                      [value]="dt.filters['affiliationStartDate'] ? dt.filters['affiliationStartDate'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" style="left: 0px">
                    <input pInputText type="date"
                      (change)="setDownloadFlag(); dt.filter($event.target.value, 'affiliationEndDate', 'equals')"
                      [value]="dt.filters['affiliationEndDate'] ? dt.filters['affiliationEndDate'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'city', 'contains')"
                      [value]="dt.filters['city'] ? dt.filters['city'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'state', 'contains')"
                      [value]="dt.filters['state'] ? dt.filters['state'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'country', 'contains')"
                      [value]="dt.filters['country'] ? dt.filters['country'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'address', 'contains')"
                      [value]="dt.filters['address'] ? dt.filters['address'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'affiliationAmount', 'equals')"
                      [value]="dt.filters['affiliationAmount'] ? dt.filters['affiliationAmount'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <p-dropdown [options]="couponFilterOptions" optionLabel="label" optionValue="value"
                      [showClear]="true" appendTo="body" placeholder="Select"
                      [ngModel]="dt.filters['couponApplied'] ? dt.filters['couponApplied'].value : null"
                      (onChange)="setDownloadFlag(); dt.filter($event.value, 'couponApplied', 'equals')">
                    </p-dropdown>
                  </th>
                  <th class="BankDteailsTD show-col"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'couponAmount', 'equals')"
                      [value]="dt.filters['couponAmount'] ? dt.filters['couponAmount'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'totalAffiliationAmount', 'equals')"
                      [value]="dt.filters['totalAffiliationAmount'] ? dt.filters['totalAffiliationAmount'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'gstAmount', 'equals')"
                      [value]="dt.filters['gstAmount'] ? dt.filters['gstAmount'].value : ''" />
                  </th>
                  <th class="text-nowrap p-element p-frozen-column action-button-td" style="justify-content: center;">
                    <div class="buttonColumn">
                      <button class="addBTn" (click)="addColumns()" [ngClass]="hide ? 'show-column ' : 'hide-column'">
                        + Show Column
                      </button>
                      <button class="removeBTn" (click)="removeColumns()"
                        [ngClass]="hide ? 'hide-column' : 'show-column '">
                        - Hide Column
                      </button>

                    </div>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-academyAffiliationRevenueList>
                <tr class="p-selectable-row">
                  <td pfrozencolumn="" class="userNameTD p-element text-nowrap">
                    <div class="textOverFlow1" pTooltip="	{{academyAffiliationRevenueList.mobileNumber}}"
                      tooltipPosition="bottom">
                      {{academyAffiliationRevenueList.mobileNumber}}
                    </div>
                  </td>

                  <td class="userNameTD">
                    {{ academyAffiliationRevenueList.academyName }}
                  </td>
                  <td class="userNameTD">
                    {{ academyAffiliationRevenueList.affiliationId }}
                  </td>
                  <td class="userNameTD">
                    {{ academyAffiliationRevenueList.affiliationLevel }}
                  </td>
                  <td class="transferCreditTD">
                    {{ academyAffiliationRevenueList.affiliationStartDate | date:'dd/MM/yyyy' }}
                  </td>
                  <td class="BankDteailsTD">
                    {{ academyAffiliationRevenueList?.affiliationEndDate | date:'dd/MM/yyyy' }}
                  </td>
                  <td class="BankDteailsTD">
                    {{ academyAffiliationRevenueList?.city }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ academyAffiliationRevenueList?.state }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ academyAffiliationRevenueList?.country }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ academyAffiliationRevenueList?.address }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ academyAffiliationRevenueList?.affiliationAmount }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ academyAffiliationRevenueList?.couponApplied }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ academyAffiliationRevenueList?.couponAmount }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ academyAffiliationRevenueList?.totalAffiliationAmount }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ academyAffiliationRevenueList?.gstAmount }}
                  </td>
                  <td class="text-nowrap p-element p-frozen-column action-button-td">

                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="7">Academy affiliation revenue list not found.</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
    <p-confirmDialog [style]="{ width: '400px' }" id="confirmDialog"></p-confirmDialog>
  </div>
</div>
